import { Button } from '@chakra-ui/react';
import { useRouter } from 'next/router';

const EditLink = ({ slug }: { slug: string }) => {
  const router = useRouter();

  return (
    <Button
      variant="link"
      textDecoration="underline"
      onClick={() => router.push(`${slug}?next=recommendations`)}
      color="primary.500"
      ml={2}
      marginBottom="-1px"
      px="6px !important"
    >
      Edit
    </Button>
  );
};

export default EditLink;
